module.exports = __webpack_public_path__ + "img/activity-yq2.cfc32410.png";